export default "__VITE_ASSET__3d1d96db__"